// Hides Add to Cart until the shopper checks the "I've had my design consultation"
// box (see sections/main-product-storm.liquid). This is a UX nudge, not enforcement —
// nothing stops a shopper from checking the box without having actually had a
// consultation — but it keeps the funnel pointed at booking one first by default.
//
// The "Reserve My Design Consultation" button only makes sense before that
// checkbox is checked — once Add to Cart appears, the consultation is already
// (self-reported) done, so it's hidden rather than left sitting next to Add to Cart.

document.addEventListener('DOMContentLoaded', () => {
  for (const gate of document.querySelectorAll('.pdp-info__consult-gate')) {
    const info = gate.closest('.pdp-info');
    const checkbox = gate.querySelector('.pdp-info__consult-checkbox');
    const hint = gate.querySelector('.pdp-info__consult-hint');
    const button = info?.querySelector('[data-consult-gated]');
    const secondaryCta = info?.querySelector('.pdp-info__secondary-cta');

    if (!checkbox || !button) continue;

    const sync = () => {
      button.hidden = !checkbox.checked;
      button.disabled = !checkbox.checked || button.dataset.unavailable === 'true';
      if (hint) hint.hidden = checkbox.checked;
      if (secondaryCta) secondaryCta.hidden = checkbox.checked;
    };

    checkbox.addEventListener('change', sync);
    sync();
  }
});
